<app-title-bar
  title="Employees"
  description="Track and manage your company team."
  [showButton]="true"
  buttonText="Add Employee"
  (buttonClick)="onAddEmployee()"
>
</app-title-bar>

<!-- Stats Cards -->
<div class="stats-container">
  <app-stats-card
    *ngFor="let stat of employeeStats; trackBy: trackByIndex"
    [title]="stat.title"
    [value]="stat.value"
    [color]="stat.color"
    [icon]="stat.icon"
    [iconClass]="stat.iconClass"
    [iconStyle]="stat.iconStyle"
  >
  </app-stats-card>
</div>

<!-- Tab Header -->
<app-tab-header [tabs]="tabItems" [activeTabId]="activeTab" (tabChange)="setActiveTab($event)">
</app-tab-header>

<!-- Tab Content -->
<app-employee-list-tab
  class="employees-tab"
  *ngIf="activeTab === 'employees'"
  [locationOptions]="locationOptions"
  [showAddModal]="showAddEmployeeModal"
  (statsRefreshNeeded)="onStatsRefreshNeeded()"
  (addModalClosed)="onAddEmployeeModalClosed()"
  (addEmployeeRequested)="onAddEmployee()"
>
</app-employee-list-tab>

<app-shifts-tab class="shifts-tab" *ngIf="activeTab === 'shifts'" (shiftChanged)="onShiftChanged()">
</app-shifts-tab>

<app-shift-schedule-tab
  class="shift-schedule-tab"
  *ngIf="activeTab === 'shift-schedule'"
  (scheduleChanged)="onScheduleChanged()"
>
</app-shift-schedule-tab>

<app-rewards-tab *ngIf="activeTab === 'rewards'"> </app-rewards-tab>

<!-- Cash Reconciliation Tab Content -->
<div *ngIf="activeTab === 'cash-reconciliation'" class="reconciliation-tab">
  <app-cash-reconciliation></app-cash-reconciliation>
</div>
<!-- Toast -->
